<div class="unauthorised d-flex flex-column justify-content-center align-items-center">
  <div class="circle d-flex justify-content-center align-items-center">
    <span class="icon-loader-circle"></span>
  </div>
  <span class="access-denied" i18n>System Maintenance In Progress</span>
  <span class="message" i18n>The system is currently undergoing maintenance. Please try logging in between 6: 30 AM and
    7: 30 AM BST.</span>
</div>